// Renderer-only webview utilities
import { getPreloadApi } from "./util/preloadAccess";
export const makeBrowserView = (src, forwardEvents, options) => {
    return getPreloadApi().browserView.createWithEvents(src, forwardEvents, options);
};
export const closeBrowserView = (viewId) => {
    return getPreloadApi().browserView.close(viewId);
};
export const positionBrowserView = (viewId, rect) => {
    return getPreloadApi().browserView.position(viewId, rect);
};
export const updateViewURL = (viewId, newURL) => {
    return getPreloadApi().browserView.updateURL(viewId, newURL);
};
